import { CurrencyEnum as A } from "@systemeio/ui";
const C = [
  A.CHILEAN_PESO,
  A.GUINEAN_FRANC,
  A.JAPANESE_YEN,
  A.RWANDAN_FRANC,
  A.UGANDAN_SHILLING,
  A.CENTRAL_AFRICAN_FRANC,
  A.WEST_AFRICAN_CFA_FRANC_BCEAO
];
export {
  C as zeroDecimalCurrencies
};
